import { render } from "./VanillaC.vue?vue&type=template&id=3f99b7bc&scoped=true"
import script from "./VanillaC.vue?vue&type=script&lang=js"
export * from "./VanillaC.vue?vue&type=script&lang=js"

import "./VanillaC.vue?vue&type=style&index=0&id=3f99b7bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f99b7bc"]])

export default __exports__